"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const gameHeight_1 = __importDefault(require("../constants/gameHeight"));
const gameWidth_1 = __importDefault(require("../constants/gameWidth"));
const sizeScreen = () => {
    const screen = document.getElementById("screen");
    if (screen) {
        const aspectRatio = gameWidth_1.default / gameHeight_1.default;
        const screenAspectRatio = window.innerWidth / window.innerHeight;
        const stretchedScale = aspectRatio >= screenAspectRatio
            ? window.innerWidth / gameWidth_1.default
            : window.innerHeight / gameHeight_1.default;
        screen.style.width = `${gameWidth_1.default * stretchedScale}px`;
        screen.style.height = `${gameHeight_1.default * stretchedScale}px`;
    }
};
exports.default = sizeScreen;
